import get from 'lodash/get'

import Storage from 'repositories/Storage'
import loginStorage from 'utils/loginStorage'
import { compareValue, getTenantId } from 'utils/commonFunctions'

const DEFAULT_STORAGE_KEY = 'reception'

export function getCheckinAuthHeader(
  localStorageKey: string,
  loginByGeneralReceptionNumber = false,
  storageKey = DEFAULT_STORAGE_KEY
): Record<string, string> {
  const storage = Storage(storageKey)
  const dataSessionList = loginStorage.getCheckinAuthData(localStorageKey) || []
  const currentTenantId = getTenantId() || storage.read('tenantId')
  const currentSession = dataSessionList.find((s: Record<string, unknown>) =>
    loginByGeneralReceptionNumber
      ? compareValue(s.generalReceptionNumber, currentTenantId)
      : compareValue(s.uid, currentTenantId)
  )
  return {
    uid: get(currentSession, 'uid', ''),
    client: get(currentSession, 'client', ''),
    'access-token': get(currentSession, 'accessToken', ''),
  }
}
